import { render, staticRenderFns } from "./TaskCenter.vue?vue&type=template&id=695645aa&scoped=true&"
import script from "./TaskCenter.vue?vue&type=script&lang=js&"
export * from "./TaskCenter.vue?vue&type=script&lang=js&"
import style0 from "./TaskCenter.vue?vue&type=style&index=0&id=695645aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695645aa",
  null
  
)

export default component.exports